import React from 'react';
import { RouterProvider } from 'react-router-dom';
import { AllProviders } from '@/providers/AllProviders';
import { ThemeProvider } from '@/theme/ThemeProvider';
import { router } from '@/router';
import { config } from '@/environment';

// ThemeProvider sits ABOVE the rest, the same way the phone apps mount it: it has
// no dependency on the API client, and everything — landing page, legal pages and
// the two email-link cards — needs to be themed.
export const App: React.FC = () => (
    <ThemeProvider>
        <AllProviders
            apiConfig={{
                baseUrl: config.api.baseUrl,
                timeout: config.api.timeout,
                headers: config.api.headers,
                // Identifies the caller in the API's logs. It is NOT a version gate
                // here: the gate only runs on POST /login, which this site never
                // calls. See environment/index.ts.
                appName: 'web',
            }}
            onError={(error, context) => {
                if (config.debug.enabled) {
                    console.error(`[busLineWeb] ${context.module}/${context.action}`, error);
                }
            }}
        >
            <RouterProvider router={router} />
        </AllProviders>
    </ThemeProvider>
);
